import { createAsyncAction } from 'typesafe-actions';
import { IdType } from '@rootTypes/common';
import { FhqInviteTemplates } from '@rootTypes/fhq';

// eslint-disable-next-line import/prefer-default-export
export const fetchFhqTemplates = createAsyncAction(
  'FETCH_FHQ_TEMPLATE_REQUEST',
  'FETCH_FHQ_TEMPLATE_SUCCESS',
  'FETCH_FHQ_TEMPLATE_FAILURE',
)<IdType[], FhqInviteTemplates[], Error>();
